module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_BNI.473c64ed.png";